'use strict';

var ToWords = require('./lib/to-words');
var toWords = new ToWords();
module.exports = function (number) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return toWords.convert(number, options);
};